import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Dimensions } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';

const { width } = Dimensions.get('window');

const FAQScreen = () => {
    const { colors } = useTheme();
    const isMobile = width < 768;

    const [expandedId, setExpandedId] = React.useState(null);

    const faqs = [
        {
            id: 1,
            category: 'General',
            question: 'What is Modern Munshiji?',
            answer: 'Modern Munshiji is a comprehensive financial services platform offering calculators, GST filing, ITR filing, business registrations, and RTO services. We combine technology with trusted expertise to make accounting simple and stress-free.'
        },
        {
            id: 2,
            category: 'General',
            question: 'How do I create an account?',
            answer: 'Click on the "Login/Signup" button in the header to create a new account. You can register using your email address and create a secure password.'
        },
        {
            id: 3,
            category: 'Calculators',
            question: 'Are the calculators free to use?',
            answer: 'Yes! All our financial calculators are completely free to use. This includes EMI, SIP, Income Tax, GST, and many more calculators.'
        },
        {
            id: 4,
            category: 'Calculators',
            question: 'How accurate are the tax calculations?',
            answer: 'Our calculators use the latest tax slabs and rules as per the Income Tax Department of India. However, for complex tax situations, we recommend consulting with a tax professional.'
        },
        {
            id: 5,
            category: 'Tools',
            question: 'Can I generate GST-compliant invoices?',
            answer: 'Yes! Our Invoice Generator creates GST-compliant invoices with proper tax breakdowns. You can add CGST, SGST, IGST as needed and export them as PDF.'
        },
        {
            id: 6,
            category: 'Tools',
            question: 'How do I save my quotations?',
            answer: 'Quotations can be exported as PDF for sharing. If you have an account, your work is saved automatically and you can access it from your dashboard.'
        },
        {
            id: 7,
            category: 'Services',
            question: 'What documents are needed for GST registration?',
            answer: 'For GST registration, you typically need: PAN card, Aadhaar card, Bank account details, Business address proof, and Photographs. Contact us for a detailed list based on your business type.'
        },
        {
            id: 8,
            category: 'Services',
            question: 'How long does ITR filing take?',
            answer: 'ITR filing typically takes 1-3 business days depending on the complexity of your returns. Simple salaried returns can be filed within 24 hours.'
        },
        {
            id: 9,
            category: 'Support',
            question: 'How can I contact support?',
            answer: 'You can reach us via email at shubham@modernmunshiji.com or call us at +91 75033 44297. Our support team is available Monday to Saturday, 10 AM to 7 PM.'
        },
        {
            id: 10,
            category: 'Support',
            question: 'What is your refund policy?',
            answer: 'For paid services, refunds are processed on a case-by-case basis. If you are not satisfied with our service, please contact us within 7 days of purchase.'
        },
    ];

    const toggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 16,
            color: 'rgba(255,255,255,0.8)',
            textAlign: 'center',
            maxWidth: 600,
        },
        content: {
            padding: 20,
            maxWidth: 800,
            alignSelf: 'center',
            width: '100%',
        },
        faqItem: {
            backgroundColor: colors.surface,
            borderRadius: 10,
            marginBottom: 12,
            borderWidth: 1,
            borderColor: colors.border,
            overflow: 'hidden',
        },
        faqHeader: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 18,
        },
        faqQuestion: {
            flex: 1,
            fontSize: 15,
            fontWeight: '600',
            color: colors.text,
            paddingRight: 16,
        },
        faqCategory: {
            fontSize: 11,
            color: '#c9a44e',
            fontWeight: '600',
            textTransform: 'uppercase',
            marginBottom: 6,
        },
        faqBody: {
            paddingHorizontal: 18,
            paddingBottom: 18,
            backgroundColor: colors.background,
        },
        faqAnswer: {
            fontSize: 14,
            color: colors.textSecondary,
            lineHeight: 22,
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <Text style={styles.heroTitle}>Frequently Asked Questions</Text>
                    <Text style={styles.heroSubtitle}>
                        Find quick answers to common questions about our services and tools
                    </Text>
                </View>

                <View style={styles.content}>
                    {faqs.map((faq) => (
                        <TouchableOpacity
                            key={faq.id}
                            style={styles.faqItem}
                            onPress={() => toggleExpand(faq.id)}
                            activeOpacity={0.8}
                        >
                            <View style={styles.faqHeader}>
                                <View style={{ flex: 1 }}>
                                    <Text style={styles.faqCategory}>{faq.category}</Text>
                                    <Text style={styles.faqQuestion}>{faq.question}</Text>
                                </View>
                                <Ionicons
                                    name={expandedId === faq.id ? 'chevron-up' : 'chevron-down'}
                                    size={20}
                                    color={colors.textSecondary}
                                />
                            </View>
                            {expandedId === faq.id && (
                                <View style={styles.faqBody}>
                                    <Text style={styles.faqAnswer}>{faq.answer}</Text>
                                </View>
                            )}
                        </TouchableOpacity>
                    ))}
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default FAQScreen;
